import React from "react";

// Shimmer placeholder shown in place of a Strapi webinar/batch date while
// EventContext is still fetching, so the static fallback date never flashes.
const WebinarDateSkeleton: React.FC<{ width?: number }> = ({ width = 170 }) => (
  <span
    className="webinarDateSkeleton"
    style={{ width }}
    role="status"
    aria-label="Loading date"
  />
);

export default WebinarDateSkeleton;
